// extracted by mini-css-extract-plugin
module.exports = {"dragger":"Upload_dragger__32Ghm","container":"Upload_container__13D70","text":"Upload_text__JLNMV","link":"Upload_link__2KR5o","hint":"Upload_hint__2V-O8"};